<template>
  <div class="o-initial-access">
    <MoleculeInitialAccess/>
  </div>
</template>

<script>
export default {
  name: 'OrganismInitialAccess',

  components: {
    MoleculeInitialAccess: () => import('@/components/molecules/MoleculeInitialAccess')
  }
}
</script>
